import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class ListPropsBuilder extends PropsBuilder<'list'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { background: { visualEffect } } });
    return this;
  };

  constructor(props: PartialPropsOf<'list'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
